export interface ConfirmOptions {
  /** Body text. The question being asked. */
  message: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Styles the confirm button as destructive. */
  destructive?: boolean;
}

type Requester = (options: ConfirmOptions) => Promise<boolean>;

let requester: Requester | null = null;

/**
 * Registers the host that renders confirmations. Called by
 * ConfirmProvider; there is only ever one host.
 */
export const setConfirmRequester = (next: Requester | null) => {
  requester = next;
};

/**
 * Asks the user to confirm an action, resolving true when they accept.
 *
 * A plain module function rather than a hook because the callers are
 * event handlers and helpers scattered across the app, many of which
 * are not components.
 *
 * Falls back to window.confirm if no host is mounted. That keeps a
 * destructive action gated even in a context that never renders the
 * provider - silently returning true would delete things unasked.
 */
export const confirm = (options: ConfirmOptions): Promise<boolean> => {
  if (requester) return requester(options);
  return Promise.resolve(window.confirm(options.message));
};
